import { EmailInUseSchoolUserRelation } from '@schooly/api';
import { CreateParentForm } from '@schooly/components/applications';
import { SchoolUserRole } from '@schooly/constants';

export const getEmailInUseForSchoolErrorTextId = (canAdd: boolean) => {
  return canAdd
    ? 'applications-ErrorEmail-UsedByAccount-AddExisting'
    : 'applications-ErrorEmail-UsedByAccount-NoAccess';
};

export const getEmailInUsePublicErrorTextId = (canLogin: boolean) => {
  return canLogin
    ? 'applications-ErrorEmail-UsedByAccount-AskToCreateApplication'
    : 'applications-ErrorEmail-UsedByAccount-InviteParent';
};

export const getEmailInUseSchoolUserRelation = (relations: EmailInUseSchoolUserRelation[]) => {
  return (
    relations.find((user) => user.user_type === SchoolUserRole.Parent) ??
    relations.find((user) => user.user_type === SchoolUserRole.Staff)
  );
};

type EmailIsDuplicatedInApplicationOptions = {
  email: string;
  parentId: string;
  allParents: CreateParentForm[];
};

export const emailIsDuplicatedInApplication = ({
  email,
  parentId,
  allParents,
}: EmailIsDuplicatedInApplicationOptions) => {
  return allParents.some(
    (p) => p.id !== parentId && p.email?.toLowerCase() === email.toLowerCase(),
  );
};
